// extracted by mini-css-extract-plugin
export var inline = "_vf-0";